import { formatDate } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RouterService } from '../../../utility/router-service';
import { HttpService } from '../../../utility/http-service';

@Component({
  selector: 'app-client-dataset-editor',
  standalone: false,
  templateUrl: './upload-confirmation.component.html',
  styleUrl: './upload-confirmation.component.css'
})
export class UploadConfirmationComponent {

  public data: any;
  public editMode = false;
  private originalConflictSet = new Set<string>();

  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public model: any,
    private router: RouterService,
    private http: HttpService
  ) {
    this.data = model.body;

    const conflictApis: string[] = this.data.conflictingApis ?? [];
    this.originalConflictSet = new Set(conflictApis.map((a: string) => a.toLowerCase()));

    // Mark rows that were originally conflicted so we know which to make editable
    this.data.records?.forEach((row: any) => {
      row._wasConflict = this.originalConflictSet.has((row.api ?? '').toLowerCase());
    });
  }

  /** True while any row still has an API that was in the original conflict list. */
  get hasConflicts(): boolean {
    return this.data.records?.some((row: any) =>
      this.originalConflictSet.has((row.api ?? '').toLowerCase())
    ) ?? false;
  }

  isConflict(api: string): boolean {
    return this.originalConflictSet.has((api ?? '').toLowerCase());
  }

  toggleEditMode(): void {
    this.editMode = !this.editMode;
  }

  onApiEdit(row: any, event: Event): void {
    row.api = (event.target as HTMLInputElement).value.trim();
  }

  getStateClass(editState: any): string {
    if (editState === 'New') return 'state-new';
    if (editState === 'Removed') return 'state-removed';
    return 'state-updated';
  }

  formatDate(date?: any): string {
    if (!date) return '';
    return formatDate(date, 'yyyy/MM/dd', 'en-US');
  }

  acceptChanges(): void {
    const formData = new FormData();
    formData.append('schedules', JSON.stringify(this.data.records));
    this.http.post('FracX/UploadAcceptChanges', () => {
      this.router.reloadPage();
    }, null, formData);
  }

  discard(): void {
    this.dialogRef.close();
  }
}
